import classNames from "classnames";
import Currency from "components/Currency";

interface PropsType {
    label?: string,
    value?: string | undefined,
    error?: string | undefined,
    onChange?: (value: string) => void,
    disabled?: boolean,
    placeholder?: string,
    maxLength?: number | undefined,
    onKeyDown?: React.KeyboardEventHandler<HTMLInputElement> | undefined,
    enableCurrency?: boolean,
}

export function InputText({ label, value, error, onChange = () => { }, disabled = false, onKeyDown, placeholder, maxLength, enableCurrency = false, }: PropsType) {
    return (
        <div>
            {label && label?.length > 0 && (
                <label className="block mb-2 text-sm font-medium text-gray-900">{label}</label>
            )}
            <div className="relative">
                {enableCurrency && (
                    <div className="absolute inset-y-0 start-0 flex items-center ps-2.5 pointer-events-none">
                        <Currency />
                    </div>
                )}
                <input
                    type="text"
                    className={
                        classNames(
                            " border text-gray-900 text-sm rounded-lg focus:outline-none focus:ring-1 focus:border w-full py-2.5",
                            {
                                "ps-6 pe-2.5": enableCurrency,
                                "px-2.5": !enableCurrency,
                                "bg-gray-50 border-gray-300 focus:border-blue-500 focus:ring-blue-500": !disabled && !error,
                                "bg-gray-50 border-red-500 focus:border-red-500 focus:ring-red-500": !disabled && error,
                                "bg-gray-200 border-gray-300 focus:border-blue-500 focus:ring-blue-500 cursor-not-allowed": disabled
                            },
                        )
                    }
                    value={value}
                    onChange={(e) => onChange(e.target.value ?? "")}
                    disabled={disabled}
                    onKeyDown={onKeyDown}
                    placeholder={placeholder}
                    maxLength={maxLength}
                />
            </div>

            {error && (
                <p className="mt-1.5 text-xs text-red-600 dark:text-red-500">{error}</p>
            )}
        </div>
    );
}